import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChevronIcon from '@assets/img/icons/chevron.svg?react';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';

import { H3 } from '@/components/Typography/Typography';
import { Button } from '@/components/ui/Button/Button';

import { MyTicketList } from './MyTicketList/MyTicketList';

import css from './styles.module.scss';

const Tickets: FC = () => {
  const [isListOpen, setIsListOpen] = useState(false);

  const toggleList = (): void => setIsListOpen((state) => !state);
  const { t } = useTranslation();

  return (
    <div className={css.tickets}>
      <AnimatePresence>
        {isListOpen && (
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={css.topGradient}
          ></motion.span>
        )}
      </AnimatePresence>
      <Button
        onClick={toggleList}
        variant="transparent"
        className={cn('flex flex-col items-center pt-2 pb-4', css.toggleList)}
      >
        <ChevronIcon
          className={cn(
            'size-[24px] shrink-0 transition-all duration-300 text-white/40 -rotate-90',
            isListOpen && 'rotate-90',
          )}
        />
        <H3 weight="bold">{t('My tickets')}</H3>
      </Button>
      <MyTicketList isOpen={isListOpen} />
    </div>
  );
};

export { Tickets };
